import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IEventLinkDTO, IEventLinksDAO, IEventLinkType } from '../event-links.dao';
import * as URL from '../../constants/api/event-links-api.constants';

export class EventLinksDAO implements IEventLinksDAO {
    public async createEventLink(payload, params) {
        const response = await this.apiClient.post<void>(URL.EVENT_LINK_CREATE_URL, { ...params, ...payload });
        return response.parsedResponse;
    }
    public async deleteEventLink(linkId, params) {
        const response = await this.apiClient.delete<void>(URL.EVENT_LINK_EDIT_URL, { ...params, linkId: linkId });
        return response.parsedResponse;
    }
    public async editEventLink(linkId, payload, params) {
        const response = await this.apiClient.put<void>(URL.EVENT_LINK_EDIT_URL, { ...params, ...payload, linkId: linkId });
        return response.parsedResponse;
    }
    public async getEventLinkTypes(params) {
        const response = await this.apiClient.get<IEventLinkType[]>(URL.EVENT_LINK_TYPES_URL, params);
        return response.parsedResponse;
    }
    public async getEventLinks(params) {
        const response = await this.apiClient.get<IEventLinkDTO[]>(URL.EVENT_LINKS_URL, params);
        return response.parsedResponse;
    }

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {}
}
